"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var hairColours = exports.hairColours = [{
  name: "Black",
  code: "rgba(009,008,006,1)"
}, {
  name: "Off Black",
  code: "rgba(044,034,043,1)"
}, {
  name: "Dark Gray",
  code: "rgba(113,099,090,1)"
}, {
  name: "Medium Gray",
  code: "rgba(183,166,158,1)"
}, {
  name: "Light Gray",
  code: "rgba(214,196,194,1)"
}, {
  name: "Platinum Blonde",
  code: "rgba(202,191,177,1)"
}, {
  name: "Bleached Blonde",
  code: "rgba(220,208,186,1)"
}, {
  name: "White Blonde",
  code: "rgba(255,245,225,1)"
}, {
  name: "Light Blonde",
  code: "rgba(230,206,168,1)"
}, {
  name: "Golden Blonde",
  code: "rgba(229,200,168,1)"
}, {
  name: "Ash Blonde",
  code: "rgba(222,188,153,1)"
}, {
  name: "Honey Blonde",
  code: "rgba(184,151,120,1)"
}, {
  name: "Strawberry Blonde",
  code: "rgba(165,107,070,1)"
}, {
  name: "Light Red",
  code: "rgba(181,082,057,1)"
}, {
  name: "Dark Red",
  code: "rgba(141,074,067,1)"
}, {
  name: "Light Auburn",
  code: "rgba(145,085,061,1)"
}, {
  name: "Dark Auburn",
  code: "rgba(083,061,050,1)"
}, {
  name: "Dark Brown",
  code: "rgba(059,048,036,1)"
}, {
  name: "Golden Brown",
  code: "rgba(085,072,056,1)"
}, {
  name: "Medium Brown",
  code: "rgba(078,067,063,1)"
}, {
  name: "Chestnut Brown",
  code: "rgba(080,068,068,1)"
}, {
  name: "Brown",
  code: "rgba(106,078,066,1)"
}, {
  name: "Light Brown",
  code: "rgba(167,133,106,1)"
}, {
  name: "Ash Brown",
  code: "rgba(151,121,097,1)"
}];
var skinTones = exports.skinTones = [{
  code: "rgba(255,223,196,1)"
}, {
  code: "rgba(240,213,190,1)"
}, {
  code: "rgba(238,206,179,1)"
}, {
  code: "rgba(225,184,153,1)"
}, {
  code: "rgba(229,194,152,1)"
}, {
  code: "rgba(255,220,178,1)"
}, {
  code: "rgba(229,184,143,1)"
}, {
  code: "rgba(229,160,115,1)"
}, {
  code: "rgba(231,158,109,1)"
}, {
  code: "rgba(219,144,101,1)"
}, {
  code: "rgba(206,150,124,1)"
}, {
  code: "rgba(198,120,86,1)"
}, {
  code: "rgba(186,108,73,1)"
}, {
  code: "rgba(165,114,87,1)"
}, {
  code: "rgba(240,200,201,1)"
}, {
  code: "rgba(221,168,160,1)"
}, {
  code: "rgba(185,124,109,1)"
}, {
  code: "rgba(168,117,108,1)"
}, {
  code: "rgba(173,100,82,1)"
}, {
  code: "rgba(92,56,54,1)"
}, {
  code: "rgba(203,132,66,1)"
}, {
  code: "rgba(189,114,60,1)"
}, {
  code: "rgba(112,65,57,1)"
}, {
  code: "rgba(163,134,106,1)"
}, {
  code: "rgba(135,4,0,1)"
}, {
  code: "rgba(113,1,1,1)"
}, {
  code: "rgba(67,0,0,1)"
}, {
  code: "rgba(91,0,1,1)"
}, {
  code: "rgba(48,46,46,1)"
}, {
  code: "rgba(0,0,0,1)"
}];